import axios from 'axios'
import { ZKEX_SERVICES_BASE_URL } from 'config'
import { Ether, TokenSymbol } from 'types'

export function faucet(params: {
  type: 1 | 2 // 1: L1 faucet, 2: L2 faucet
  receiveAddress: string // receive address
  symbol: TokenSymbol // token symbol
  amount: Ether // amount (e.g. "1.02")
  captchaToken: string // google recaptcha token
  subAccountId?: number // L2 required
  chainId?: number // layer2 chain id, L1 required
}) {
  return axios.post(`/faucet`, params, {
    baseURL: ZKEX_SERVICES_BASE_URL,
  })
}
